import { Editor, JSONContent } from '@tiptap/react'
import { marked } from 'marked'
import { DOMParser as ProseMirrorDOMParser } from 'prosemirror-model'

export function markdownDeserializer(
  schema: Editor['schema'],
  content: string
): JSONContent {
  const html = marked.parse(content) as string

  const parser = new DOMParser()
  const { body } = parser.parseFromString(html, 'text/html')

  // append original source as a comment that nodes can access
  body.append(document.createComment(content))

  const state = ProseMirrorDOMParser.fromSchema(schema).parse(body)
  const json = state.toJSON()
  return json
}
